import gql from 'graphql-tag';
import { cookieValueFieldsFragment } from '../fragments';

export const completeOtpLoginMutation = gql`
  mutation CompleteOtpLogin($tenant: String!, $userIdentifier: UserIdentifierInput!, $otp: String!) {
    completeOtpLogin(tenant: $tenant, userIdentifier: $userIdentifier, otp: $otp) {
      success
      cookies {
        ...CookieValueFields
      }
    }
  }

  ${cookieValueFieldsFragment}
`;